/* T8 Search drawer: the header search icons open the right-hand panel; typing queries Shopify predictive search and renders
   sections/t8-search-results.liquid (Section Rendering API) — suggestions, collections, product cards; the × clears;
   chips (popular + suggestions) search their word; Enter / the icon go to the full results page */
(function () {
  'use strict';
  // match on title, type, tags, vendor and variant names (so "botanical" finds tagged prints); sold-out products go last
  var PARAMS = '&resources[type]=query,product,collection,page&resources[limit]=8&resources[limit_scope]=each'
    + '&resources[options][fields]=title,product_type,tag,vendor,variants.title&resources[options][unavailable_products]=last'
    + '&section_id=t8-search-results';
  function init() {
    var sd = document.querySelector('[data-t8-sd]'); if (!sd || sd.dataset.ready) return; sd.dataset.ready = '1';
    var lead = sd.querySelector('[data-t8-sd-lead]'), input = sd.querySelector('[data-t8-sd-input]'), idle = sd.querySelector('[data-t8-sd-idle]'), results = sd.querySelector('[data-t8-sd-results]'), clear = sd.querySelector('[data-t8-sd-clear]');
    var root = sd.dataset.root || '/', last = null, timer = null, opener = null, ctrl = null, cache = {};
    function open(e) {
      if (e) e.preventDefault();
      opener = document.activeElement;
      // close the mobile menu drawer if the search came from there
      var md = document.querySelector('[data-drawer].is-open'); if (md) { var x = md.querySelector('[data-drawer-close]'); if (x) x.click(); }
      sd.classList.add('is-open'); sd.setAttribute('aria-hidden', 'false'); document.body.classList.add('t8-sd-lock');
      setTimeout(function () { input.focus(); }, 60);
    }
    function close() {
      sd.classList.remove('is-open'); sd.setAttribute('aria-hidden', 'true'); document.body.classList.remove('t8-sd-lock');
      if (opener && opener.focus) opener.focus();
    }
    document.querySelectorAll('[data-t8-sd-open]').forEach(function (a) { a.addEventListener('click', open); });
    sd.querySelectorAll('[data-t8-sd-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sd.classList.contains('is-open')) close(); });
    // popular chips and the suggestion chips rendered into the results both fill the input
    sd.addEventListener('click', function (e) {
      var c = e.target.closest('[data-t8-sd-chip]'); if (!c) return;
      e.preventDefault(); input.value = c.dataset.t8SdChip; sync(); search(); input.focus();
    });
    if (clear) clear.addEventListener('click', function () { input.value = ''; sync(); search(); input.focus(); });
    function sync() { if (clear) clear.hidden = !input.value; }
    function show(payload) {
      var n = Number(payload.dataset.count) || 0;
      results.innerHTML = payload.innerHTML; results.hidden = false; results.classList.remove('is-loading');
      lead.hidden = true; idle.hidden = n > 0;   // no matches: keep the popular searches under the message
    }
    function search() {
      var q = input.value.trim();
      if (q === last) return; last = q;
      if (q.length < 2) { if (ctrl) ctrl.abort(); results.hidden = true; results.innerHTML = ''; idle.hidden = false; lead.hidden = false; return; }
      if (cache[q]) { show(cache[q]); return; }
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      results.classList.add('is-loading');
      fetch(root + 'search/suggest?q=' + encodeURIComponent(q) + PARAMS, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (t) {
          var p = new DOMParser().parseFromString(t, 'text/html').querySelector('[data-t8-sd-payload]');
          if (!p) return;
          cache[q] = p;
          if (input.value.trim() === q) show(p);
        })
        .catch(function () { results.classList.remove('is-loading'); });
    }
    input.addEventListener('input', function () { sync(); clearTimeout(timer); timer = setTimeout(search, 200); });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
